import type * as v from 'valibot';

import type { compareSchema } from '.';
import type { baseCompareSchema, offerSchema } from './base';

export type Category = {
  label: string;
  offers: CreditCardOffer[];
};

export type BaseComparePage = v.InferOutput<typeof baseCompareSchema>;
export type ComparePage = v.InferOutput<typeof compareSchema>;
export type OffersByCategory = ComparePage['offersByCategory'];
export type BaseCreditCardOffer = v.InferOutput<typeof offerSchema>;
export type CreditCardOffer = ComparePage['bestOffer'];

export const COMPARE_CATEGORY_BCC_KEY = 'the-best-credit-cards';
export const ALL_CATEGORIES = [
  'airline-credit-cards',
  'bad-credit-cards',
  'balance-transfer-credit-cards',
  'business-credit-cards',
  'cash-rewards-credit-cards',
  'credit-card-bonus-offers',
  'excellent-credit-cards',
  'gas-credit-cards',
  'hotel-credit-cards',
  'low-apr-credit-cards',
  'low-interest-credit-cards',
  'nw-search',
  'pers-rec-results',
  'recommended_placement',
  'restaurant-credit-cards',
  'rewards-credit-cards',
  'secured-credit-cards',
  'student-credit-cards',
  COMPARE_CATEGORY_BCC_KEY,
  'shadow-card',
  'travel-miles-credit-cards',
  'zero-percent-credit-cards',
  'cardfinder-exclusion',
  'cardalyzer-exclusion',
] as const;
export type AllCategories = (typeof ALL_CATEGORIES)[number];
export type ShowedCategories = Extract<
  AllCategories,
  | 'the-best-credit-cards'
  | 'travel-miles-credit-cards'
  | 'balance-transfer-credit-cards'
  | 'zero-percent-credit-cards'
  | 'cash-rewards-credit-cards'
  | 'rewards-credit-cards'
>;
